<template>
  <main>
    <div class="main-container">

      <b-alert v-model="error" variant="danger" dismissible>
        {{ msg_alert }}
      </b-alert>

      <h3 class="custom-title text-center text-primary mb-4">{{ title }} client</h3>

      <!-- Form User -->
      <b-form @submit="onSubmit" id="form_send">
        <b-form-input v-model="form.name" placeholder="Nom"></b-form-input>
        <b-form-input v-model="form.tel" placeholder="Téléphone" type="tel"></b-form-input>
        <b-form-input v-model="form.fid" placeholder="Carte de fidélité"></b-form-input>

        <b-form-checkbox v-model="form.is_card">Cartes Pokémon ?</b-form-checkbox>

        <div v-if="form.is_card" class="d-flex">
          <b-form-checkbox v-model="form.is_vf" class=" mr-4">VF
          </b-form-checkbox>

          <b-form-checkbox v-model="form.is_vo" class=" mr-4">VO
          </b-form-checkbox>

          <b-form-checkbox v-model="form.is_kr" class="">KR
          </b-form-checkbox>
        </div>

        <b-form-textarea v-model="form.notes" placeholder="Notes" rows="5" max-rows="10"></b-form-textarea>

        <b-button variant="primary" type="submit">Go!</b-button>
      </b-form>

    </div>
  </main>

</template>

<style lang="scss" scoped>

@import "src/assets/styles/custom_variables";

span.float-right {
  cursor: pointer;
  margin-left: 5%;
}

input, textarea {
  margin: 20px 0;
}
</style>

<script>

import {create_user, update_user} from "@/services/ApiServices";

export default {
  name: "create-user-view",
  props: ['user', 'is_update'],
  data: () => {
    return {
      is_update: false,
      title: "Nouveau",
      error: false,
      msg_alert: '',
      form: {
        name: '',
        tel: '',
        fid: '',
        notes: '',
        is_card: false,
        is_vf: false,
        is_vo: false,
        is_kr: false,
      }
    }
  },
  methods: {
    onSubmit(event) {
      event.preventDefault();
      if (this.is_update) {
        update_user(this.form.id, this.form).then(_ => {
          window.location.href = '/list/users';
        }).catch(error => {
          this.error = true;
          this.msg_alert = error.message
        })
      } else {
        console.log("error", this.form);
        create_user(this.form).then(_ => {
          window.location.href = '/';
        }).catch(error => {
          this.error = true;
          this.msg_alert = error.message
        })
      }
    }
  },
  mounted() {
    if (this.user) { // if user pass in parameter, update it else create new
      const toBoolean = value => [true, 1, '1', 'true', 'True'].includes(value)
      this.is_update = true
      this.form = {
        ...this.user,
        is_card: toBoolean(this.user.is_card),
        is_vf: toBoolean(this.user.is_vf),
        is_vo: toBoolean(this.user.is_vo),
        is_kr: toBoolean(this.user.is_kr),
      }
      this.title = "Modification"
    }
  }
}
</script>
